import React from 'react';
import { Link } from 'react-router-dom';
import CategoryWrapper from '../Category/CategoryWrapper';
import CategoryHeader from '../Category/CategoryHeader';
import CategoryBody from '../Category/CategoryBody';
import ProductHorizontal from '../ProductHorizontal';
import { useSelector } from 'react-redux';
import { postsApplicationState$ } from '../../redux/selectors';

export default function ApplicationPosts() {
  const applicationPosts = useSelector(postsApplicationState$);

  if (!applicationPosts || (applicationPosts && applicationPosts.length === 0)) {
    return null;
  }

  return (
    <CategoryWrapper>
      <CategoryHeader
        left={
          <>
            <i className="fa fa-android" aria-hidden="true"></i>&nbsp;Ứng Dụng Nổi Bật
          </>
        }
        right={
          <Link to="/applications" className="text-decoration-none">
            <div className="d-flex flex-direction-row align-items-center"><img
              src="https://salt.tikicdn.com/ts/upload/b2/14/5f/811ab1cf876d0e9d9a3de7c886ca7c59.png"
              alt="Icon"
              width="20"
              height="20"
            />&nbsp;XEM THÊM</div>
          </Link>
        }
      />
      <CategoryBody itemPerRow={2}>
        {applicationPosts && applicationPosts.map(item => {
          const { _id, banner, title, ...rest } = item;
          return (
            <ProductHorizontal
              key={_id}
              path={`/applications/${_id}`}
              title={title}
              {...rest}
            />
          )
        })}
      </CategoryBody>
    </CategoryWrapper>
  );
}